/* eslint-disable @typescript-eslint/no-explicit-any */
type CountryCurrency = {
  currency: {
    name: string;
    symbol: string;
    fullForm: string;
  };
};

export const countriesWithCurrency: CountryCurrency[] = [
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ANG',
      symbol: 'ƒ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XPF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ANG',
      symbol: 'ANG',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AFN',
      symbol: '؋',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ALL',
      symbol: 'L',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DZD',
      symbol: 'دج',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AOA',
      symbol: 'Kz',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ARS',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AMD',
      symbol: '֏',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AWG',
      symbol: 'ƒ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AZN',
      symbol: '₼',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BSD',
      symbol: 'B$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BHD',
      symbol: '.د.ب',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BDT',
      symbol: '৳',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BBD',
      symbol: 'Bds$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BYR',
      symbol: 'Br',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BZD',
      symbol: 'BZ$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BMD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BTN',
      symbol: 'Nu',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BOB',
      symbol: 'Bs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BAM',
      symbol: 'KM',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BWP',
      symbol: 'P',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BRL',
      symbol: 'R$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BND',
      symbol: 'B$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BGN',
      symbol: 'лв.',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'CFA',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'BIF',
      symbol: 'Fbu',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KHR',
      symbol: '៛',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CAD',
      symbol: 'C$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CVE',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KYD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CLP',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CNY',
      symbol: '¥ ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'COP',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KMF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CDF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NZD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CRC',
      symbol: '₡',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'HRK',
      symbol: 'kn',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CUC',
      symbol: 'CUC$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CZK',
      symbol: 'Kč',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DKK',
      symbol: 'kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DJF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DOP',
      symbol: 'RD$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EGP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SVC',
      symbol: '₡',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ERN',
      symbol: 'Nfk',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ETB',
      symbol: 'Br',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'FKP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DKK',
      symbol: 'Kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'FJD',
      symbol: 'FJ$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XAF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GMD',
      symbol: 'D',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GEL',
      symbol: '₾',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GHS',
      symbol: '₵',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GIP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'DKK',
      symbol: 'kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GTQ',
      symbol: 'Q',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GNF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GYD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'HTG',
      symbol: 'G',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'HNL',
      symbol: 'L',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'HKD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'HUF',
      symbol: 'Ft',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ISK',
      symbol: 'kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'INR',
      symbol: '₹',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'IDR',
      symbol: 'Rp',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'IRR',
      symbol: '﷼',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'IQD',
      symbol: 'ع.د',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'GBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ILS',
      symbol: '₪',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'JMD',
      symbol: 'J$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'JPY',
      symbol: '¥',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'JOD',
      symbol: 'د.ا',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KZT',
      symbol: '₸',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KES',
      symbol: 'Sh',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KRW',
      symbol: '₩',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KPW',
      symbol: '₩',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KWD',
      symbol: 'د.ك',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'KGS',
      symbol: 'Лв',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LAK',
      symbol: '₭',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LVL',
      symbol: 'Ls',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LBP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LSL',
      symbol: 'L',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LRD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LYD',
      symbol: 'ل.د',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CHF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LTL',
      symbol: 'Lt',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MOP',
      symbol: 'P',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MKD',
      symbol: 'ден',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MGA',
      symbol: 'Ar',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MWK',
      symbol: 'MK',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MYR',
      symbol: 'RM',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MVR',
      symbol: '.ރ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MRO',
      symbol: 'UM',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MUR',
      symbol: 'Rs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MXN',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MDL',
      symbol: 'L',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MNT',
      symbol: '₮',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MAD',
      symbol: 'د.م.',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MZN',
      symbol: 'MT',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'MMK',
      symbol: 'K',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NAD',
      symbol: 'N$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NPR',
      symbol: 'Rs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XPF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NZD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NIO',
      symbol: 'C$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NGN',
      symbol: '₦',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NZD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'NOK',
      symbol: 'Kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'OMR',
      symbol: 'ر.ع.',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PKR',
      symbol: 'Rs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ILS',
      symbol: '₪',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PAB',
      symbol: 'B/.',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PGK',
      symbol: 'K',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PYG',
      symbol: '₲',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PEN',
      symbol: 'S/.',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PHP',
      symbol: '₱',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'PLN',
      symbol: 'zł',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'QAR',
      symbol: 'ر.ق',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'RON',
      symbol: 'lei',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'RUB',
      symbol: '₽',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'RWF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SHP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'WST',
      symbol: 'T',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'STD',
      symbol: 'Db',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SAR',
      symbol: 'ر.س',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'RSD',
      symbol: 'дин. ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SCR',
      symbol: 'Rs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SLL',
      symbol: 'Le',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SGD',
      symbol: 'S$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SBD',
      symbol: 'SI$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SOS',
      symbol: 'Sh',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ZAR',
      symbol: 'R',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SDG',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'LKR',
      symbol: 'Rs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'EUR',
      symbol: '€',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XCD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SDG',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SRD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SZL',
      symbol: 'L',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SEK',
      symbol: 'kr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'CHF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'SYP',
      symbol: '£',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TWD',
      symbol: 'NT$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TJS',
      symbol: 'SM',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TZS',
      symbol: 'Sh',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'THB',
      symbol: '฿',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XOF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TOP',
      symbol: 'T$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TTD',
      symbol: 'TT$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TND',
      symbol: 'د.ت',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TRY',
      symbol: '₺',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'TMT',
      symbol: 'm',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AUD',
      symbol: 'A$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'USD',
      symbol: '$',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'UGX',
      symbol: 'Sh',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'UAH',
      symbol: '₴',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'AED',
      symbol: 'د.إ',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'UYU',
      symbol: '$U',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'UZS',
      symbol: "so'm",
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'VUV',
      symbol: 'Vt',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'VEF',
      symbol: 'Bs',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'VND',
      symbol: '₫',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'XPF',
      symbol: 'Fr',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'YER',
      symbol: '﷼',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ZMK',
      symbol: 'ZK',
      fullForm: '',
    },
  },
  {
    currency: {
      name: 'ZWL',
      symbol: 'Z$',
      fullForm: '',
    },
  },
];

export function getCurrencySymbolByName(name?: any): string {
  if (!name) return ''; // fallback if name is null/undefined
  const match = countriesWithCurrency.find(country => country.currency.name === name);
  return match?.currency.symbol || ''; // fallback if not found
}
